import { render, staticRenderFns } from "./VaIcon.vue?vue&type=template&id=17d39ee1&scoped=true&"
import script from "./VaIcon.vue?vue&type=script&lang=ts&"
export * from "./VaIcon.vue?vue&type=script&lang=ts&"
import style0 from "./VaIcon.vue?vue&type=style&index=0&id=17d39ee1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d39ee1",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17d39ee1')) {
      api.createRecord('17d39ee1', component.options)
    } else {
      api.reload('17d39ee1', component.options)
    }
    module.hot.accept("./VaIcon.vue?vue&type=template&id=17d39ee1&scoped=true&", function () {
      api.rerender('17d39ee1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/atoms/VaIcon.vue"
export default component.exports